<template>
  <div class="ProductImgSlide">
    <div class="menu flx">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        @click="goBack()"
      >
        <g fill="#505050" fill-rule="evenodd">
          <path
            fill="#505050"
            fill-rule="nonzero"
            stroke="#505050"
            stroke-width="0.05"
            d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
          />
          <path
            fill="#505050"
            fill-rule="nonzero"
            stroke="#505050"
            stroke-width="0.05"
            d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
          />
        </g>
      </svg>
      <div>
        <span
          class="tabIcon"
          :class="{'active' : isBookMark == false}"
          @click="bookMark(details.saleReferenceID,isBookMark)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17">
            <path
              fill="#505050"
              fill-rule="evenodd"
              d="M11.433 14.328V2.52a.829.829 0 0 0-.816-.84H2.45a.829.829 0 0 0-.817.84v11.808l4.426-3.252a.798.798 0 0 1 .949 0l4.425 3.252zm-4.9-1.536l-5.242 3.852c-.54.397-1.291 0-1.291-.684V2.52C0 1.128 1.097 0 2.45 0h8.167c1.353 0 2.45 1.128 2.45 2.52v13.44c0 .683-.751 1.08-1.292.684l-5.242-3.852z"
            />
          </svg>
        </span>
      </div>
    </div>
    <div v-if="details.itemMediaDTOList" class="swiper-container product-slide">
      <div class="swiper-wrapper" @click="openProductGallery = !openProductGallery">
        <div
          class="swiper-slide"
          v-if="(details.itemVideoDTOList && details.itemVideoDTOList.length && details.itemVideoDTOList[0].original) && getImageURL"
          id="0"
        >
          <video
            id="itemVideo"
            poster="../../assets/images/mall91_logo.jpg"
            :src="videoSrc"
            autoplay
            controls
            muted
            width="100%"
            height="100%"
          ></video>
        </div>
        <div
          :id="isVideoIndex(index)"
          class="swiper-slide"
          v-for="(productImage,index) in details.itemMediaDTOList"
          :key="index"
        >
          <span v-lazyload class="image__wrapper" v-if="productImage.original">
            <ImageSpinner class="image__spinner" />
            <img class="image__item" :data-url="productImage.original" alt="random image" />
          </span>
        </div>
      </div>
      <div class="swiper-pagination" v-if="details.itemMediaDTOList.length > 1"></div>
    </div>
    <div class="champion_list flx">
      <div class="credit_list">
        <div class="swiper-container latstcredit-slide">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(credit,index) in latestCreditList" :key="index">
              <div class="upper_part">
                <div class="user_img">
                  <img v-if="credit.userProfilePic" :src="credit.userProfilePic" alt="random image" />
                  <img v-else src="../../assets/images/dummy.png" alt="random image" />
                </div>
                <div class="credit_detail">
                  <p v-if="credit.winningAmount > 0" class="text">{{$t('boughtFrom',{user:((credit.userName).substr(0, 6)), city: ((credit.userCity).substr(0, 8))})}}
                  <img :src="credit.walletEarningTypeIconUrl" :alt="credit.userName" class="earn_icon" />
                  {{credit.winningAmount}} {{$t('won')}}</p>
                  <p v-if="credit.winningBCoin > 0" class="text">{{$t('boughtFrom',{user:((credit.userName).substr(0, 6)), city: ((credit.userCity).substr(0, 8))})}}
                  <img :src="credit.walletEarningTypeIconUrl" :alt="credit.userName" class="earn_icon" />
                  {{credit.winningBCoin}} {{$t('won')}}</p>
                </div>
                <p class="value">{{$t('peopleBoughtThisDeal',{people:details.peopleBought})}}</p> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="prodgallery_wrap" v-if="openProductGallery == true && details.itemMediaDTOList">
      <div class="product_Gallery">
        <span class="close_prodgallery" @click="openProductGallery = !openProductGallery">
          <i class="material-icons">close</i>
        </span>
        <div class="swiper-container gallery-top">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-if="(details.itemVideoDTOList && details.itemVideoDTOList.length && details.itemVideoDTOList[0].original) && getImageURL"
              id="0"
            >
              <video
                id="itemVideo"
                poster="../../assets/images/mall91_logo.jpg"
                :src="videoSrc"
                autoplay
                controls
                muted
                width="100%"
                height="100%"
              ></video>
            </div>
            <div
              :id="isVideoIndex(index)"
              class="swiper-slide"
              v-for="(productImage,index) in details.itemMediaDTOList"
              :key="index"
            >
              <div v-lazyload class="img_wrapper spinner_wrapper" v-if="productImage.original">
                <ImageSpinner class="image_spinner" />
                <img :data-url="productImage.original" alt />
              </div>
            </div>
          </div>
          <div class="swiper-button-next">
            <i class="material-icons">arrow_forward_ios</i>
          </div>
          <div class="swiper-button-prev">
            <i class="material-icons">arrow_back_ios</i>
          </div>
        </div>
        <div class="swiper-container gallery-thumbs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-if="(details.itemVideoDTOList && details.itemVideoDTOList.length && details.itemVideoDTOList[0].original) && getImageURL"
              id="0"
            >
              <video
                id="itemVideo"
                poster="../../assets/images/mall91_logo.jpg"
                :src="videoSrc"
                autoplay
                controls
                muted
                width="100%"
                height="100%"
              ></video>
            </div>
            <div
              :id="isVideoIndex(index)"
              class="swiper-slide"
              v-for="(productImage,index) in details.itemMediaDTOList"
              :key="index"
            >
              <div class="img_wrapper spinner_wrapper" v-if="productImage.original" v-lazyload>
                <ImageSpinner class="image_spinner" />
                <img :data-url="productImage.original" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
import ImageSpinner from "../Common/ImageSpinner";
import Swiper from "swiper";
import "../../assets/css/swiper-slider.css";
export default {
  name: "ImageSlider",
  components: { ImageSpinner },
  props: {
    dataValue: {
      required: true,
      type: Object
    },
    viewerCount: {
      type: String
    }
  },
  data() {
    return {
      details: {},
      isBookMark: true,
      viewCount: null,
      getImageURL: false,
      videoSrc: "",
      dynamicPagination: false,
      openProductGallery: false,
      latestCreditList: []
    };
  },
  methods: {
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
   
    isVideoIndex(videoIndex) {
      if (this.details.itemVideoDTOList.length) {
        videoIndex = videoIndex + 1;
      }
    },
    bookMark(productId, isBookMark) {
      var xauthid = this.$cookie.get("X-Auth-Id");
      try {
        if (this.isBookMark) {
          this.isBookMark = false;
        } else {
          this.isBookMark = true;
        }
        JSBridgePlugin.bookmarkProduct(Number(productId), isBookMark);
      } catch (err) {
        console.log(err);
      }
    },
    getLatestCredit() {
      ApiCaller(
        constant.PAYBOARD_URL,
        "commons/fetchLatestCreditTransactions",
        "get"
      ).then(data => {
        if (data.data) {
          this.latestCreditList = data.data.slice(0, 20);
          this.$nextTick(() => {
            var swiper = new Swiper(".latstcredit-slide", {
              loop: true,
              spaceBetween: 30,
              autoHeight: true,
              effect: 'fade',
              autoplay: {
                delay: 5000,
                disableOnInteraction: false
              }
            });
          });
        }
      });
    }
  },
  watch: {
    viewerCount() {
      this.viewCount = this.viewerCount;
    },
    dataValue() {
      this.details = this.dataValue;
      if (
        this.details.itemMediaDTOList &&
        this.details.itemMediaDTOList.length > 5
      ) {
        this.dynamicPagination = true;
      }
      this.$nextTick(() => {
        var swiper = new Swiper(".product-slide", {
          loop: false,
          spaceBetween: 10,
          centeredSlides: true,
          pagination: {
            el: ".swiper-pagination",
            dynamicBullets: this.dynamicPagination,
            clickable: true
          }
        });
      });
      if (
        this.details &&
        this.details.itemVideoDTOList &&
        this.details.itemVideoDTOList[0] &&
        this.details.itemVideoDTOList[0].original
      ) {
        this.videoSrc = this.details.itemVideoDTOList[0].original;
        this.getImageURL = true;
      }
    },
    openProductGallery: function(val) {
      if (val == true) {
        this.$nextTick(() => {
          var galleryThumbs = new Swiper(".gallery-thumbs", {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true
          });
          var galleryTop = new Swiper(".gallery-top", {
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            },
            thumbs: {
              swiper: galleryThumbs
            }
          });
        });
      }
    }
  },
  mounted() {
    this.getLatestCredit();
    this.details = this.dataValue;
    if (
      this.details.itemMediaDTOList &&
      this.details.itemMediaDTOList.length > 5
    ) {
      this.dynamicPagination = true;
    }
    this.$nextTick(() => {
      var swiper = new Swiper(".product-slide", {
        loop: false,
        spaceBetween: 10,
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: this.dynamicPagination,
          clickable: true
        }
      });
    });

    if (
      this.details &&
      this.details.itemVideoDTOList &&
      this.details.itemVideoDTOList[0] &&
      this.details.itemVideoDTOList[0].original
    ) {
      this.getImageURL = true;
      this.videoSrc = this.details.itemVideoDTOList[0].original;
    }
    this.viewCount = this.viewerCount;
  }
};
</script>